import { makeStyles } from '@mui/styles';

const useCheckboxFormFieldStyle = makeStyles(() => ({
  formControl: { display: 'flex', justifyContent: 'center' },
}));

export default useCheckboxFormFieldStyle;
